import { instance } from 'utils/api';

export type ViewCount = {
  total: number;
  view_by_country: Record<string, number>;
};

// GET /matomo-data — bare {total, view_by_country} for the current doctor
export const fetchViewCount = async (): Promise<ViewCount> => {
  const res = await instance.get<ViewCount>('matomo-data');

  return res.data;
};

// GET /statistics/appointments — legacy doctorAppointmentStatistics parity.
// gender keys are the raw patient-snapshot values (may be '1'/'2',
// 'male'/'female', or 'Male'/'Female' across snapshot generations) — read
// them via sumGender, never by a fixed key.
export type AppointmentStatistics = {
  // date-windowed (?startDate/?endDate)
  total: number;
  byStatus: Record<string, number>;
  byDate: Record<string, number>;
  // all-time, state=APPROVED (feeds the count card, NOT `total`)
  appointmentsCount: number;
  ageGroup: { age: string; count: number }[];
  dateGroup: { month: string; count: number }[];
  gender: Record<string, { count: number }>;
};

export const fetchAppointmentStatistics =
  async (): Promise<AppointmentStatistics> => {
    const res = await instance.get<AppointmentStatistics>(
      'statistics/appointments'
    );

    return res.data;
  };

const MALE_KEYS = ['Male', 'male', '1'];
const FEMALE_KEYS = ['Female', 'female', '2'];

const sumKeys = (
  gender: Record<string, { count: number }> | undefined,
  keys: string[]
) => keys.reduce((acc, key) => acc + Number(gender?.[key]?.count || 0), 0);

export const sumGender = (gender?: Record<string, { count: number }>) => ({
  male: sumKeys(gender, MALE_KEYS),
  female: sumKeys(gender, FEMALE_KEYS)
});
